import { useEffect } from 'react';

export function useTimer(timerLength: number, callback: () => any, deps: any[] = []) {
  useEffect(() => {
    const timer = setTimeout(() => {
      callback();
    }, timerLength);

    return () => clearTimeout(timer);
  }, deps);
}
